import React, { useEffect, useState } from 'react';
import { Col, Progress, Row } from 'antd';
import { useSelector } from 'react-redux';
import { SERVER_IP } from 'assets/Config';

const PageLoader = () => {
	const loginRedux = useSelector((state) => state.loginRedux);
	const [percent, setPercent] = useState(0);
	const [done, setDone] = useState(false);

	useEffect(() => {
		const intervalTime = 15; // Update every 15 milliseconds
		const incrementValue = 100 / (800 / intervalTime); // Increment by 1 every 15ms

		const interval = setInterval(() => {
			setPercent((prevPercent) => {
				if (prevPercent >= 100) {
					clearInterval(interval);
					return 100;
				}
				return prevPercent + incrementValue;
			});
		}, intervalTime);

		return () => clearInterval(interval);
	}, []);

	if (done) return null;

	return (
		<Row className="loader" align="middle" onAnimationEnd={() => setDone(true)}>
			<Col span={24}>
				<div className="loader_container">
					<img
						src={loginRedux?.profilePic ? SERVER_IP + loginRedux?.profilePic : require('../assets/images/logo.png')}
						style={{ width: 80, height: 80, marginBottom: 40 }}
						alt="logo"
					/>
					<Progress percent={percent} type="line" status="active" />
					<span className="shimmer-effect">FITTE.in</span>
				</div>
			</Col>
		</Row>
	);
};

export default PageLoader;
